export type DfsContestMobileView = 'lineup' | 'leaderboard' | 'matches' | 'players';

const DFS_CONTEST_VIEWS = new Set<DfsContestMobileView>([
  'lineup',
  'leaderboard',
  'matches',
  'players',
]);

export const getDfsContestMobileView = (hash: string): DfsContestMobileView => {
  const candidate = hash.replace(/^#/, '') as DfsContestMobileView;
  return DFS_CONTEST_VIEWS.has(candidate) ? candidate : 'lineup';
};

export const getDfsContestIdentifierFromPath = (pathname: string): string | null => {
  return pathname.match(/^\/dfs\/contest\/([^/]+)/)?.[1] ?? null;
};

export const getDfsBuilderIdentifierFromPath = (pathname: string): string | null => {
  return pathname.match(/^\/dfs\/build\/([^/]+)/)?.[1] ?? null;
};

export const buildDfsContestSectionHref = (
  contestIdOrAlias: string | number,
  view: DfsContestMobileView,
): string => `/dfs/contest/${contestIdOrAlias}#${view}`;
